import GenerateEAPForm from './GenerateEAPForm'
export default GenerateEAPForm